<template>
  <w-icon-wrapper
    :height='21.2'
    :width='24.097'
    icon-name='work-export-icon-message'
    view-box='0 0 24.097 21.2'
  >
    <path
      id="Pfad_58294"
      data-name="Pfad 58294"
      d="M18.1,0a1,1,0,0,0,0,2h2.586L15.89,6.793A1,1,0,1,0,17.3,8.207L22.1,3.414V6a1,1,0,0,0,2,0V0Z"
      fill="currentColor"
    />
    <path
      id="Pfad_58295"
      data-name="Pfad 58295"
      d="M23,9.17a1,1,0,0,0-1,1v7.18l-5.04-6.3.01-.01L15.7,9.48l-1.42,1.29-.06.05v.01L12,12.85,9.78,10.83v-.01l-.06-.05L3.59,5.2H14.03a1,1,0,0,0,0-2H0v18H24V10.17a1,1,0,0,0-1-1M2,6.46l5.04,4.59L2,17.35ZM3.08,19.2l5.45-6.81L12,15.55l3.47-3.16,5.45,6.81Z"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconExportMessage' };
</script>
